// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PLAYLIST_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    PLAYLIST_PAGE_LOADED() {
      return {
        isLoading: false
      };
    },
    PLAYLIST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.playlistPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
